
class WarnModalController {
    constructor($uibModalInstance, type) {
        this.type = type;
        this._$uibModalInstance = $uibModalInstance;

    }

    cancel() {
        this._$uibModalInstance.close();
    }

    next() {

    }
}

WarnModalController.$inject = ['$uibModalInstance', 'type'];

export default WarnModalController;



// WEBPACK FOOTER //
// ./client/app/warn-modal.controller.js